import GET_LANDING_QUERY from '../queries/landing/getLanding.graphql';

const landingLoader = async ({ apolloClient, pathname, useFakeData }) =>
  apolloClient.query({
    query: GET_LANDING_QUERY,
    variables: {
      path: pathname,
      useFakeData
    }
  });
export default landingLoader;
